import { createTheme, PaletteMode } from '@mui/material';
import { useMemo, useState } from 'react';
import { getDesignTokens } from './theme';

export const useColorTheme = () => {
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const [mode, setMode] = useState<PaletteMode>(
    // prefersDarkMode ? 'dark' : 'light'
    'light'
  );

  const toggleMode = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const newTheme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return {
    theme: newTheme,
    mode,
    toggleMode,
  };
};
